import React, { useState } from "react";
import Loader from "../../commanComponents/Loader";
import BackButton from "../../commanComponents/buttons/BackButton";
import svgData from "../../constants/utilities/svgData";
import { useMutation, useQuery } from "react-query";
import { communication } from "../../constants/apis/communication";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import BlueHeading from "../../commanComponents/BlueHeading";
import GreenButton from "../../commanComponents/buttons/GreenButton";
import SelectMine from "../../commanComponents/SelectMine";
import { InputBox } from "../../commanComponents/inputs/InputBox";
import { PaginationContext } from "../../constants/context/PaginationProvider";
import { getUserDetails } from "../../constants/helpers/getUserDetails";

export default function Attendance() {
  const { globalSearchString } = React.useContext(PaginationContext);
  const [searchParams] = useSearchParams();
  const activityDate = searchParams.get("activityDate");
  const createdById = searchParams.get("createdById");
  const shift = searchParams.get("shift");
  const action = searchParams.get("action");
  const gangNo = searchParams.get("gangNo")?.split(",");
  const [filteredAttendaceData, setFilteredAttendaceData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedGangNo, setSelectedGangNo] = useState(null);
  const [selectedGangObj, setSelectedGangObj] = useState(null);
  const [prevSelectedGangObj, prevSetSelectedGangObj] = useState(null);
  const [editIndex, setEditIndex] = useState("");
  const [selectedMine, setSelectedMine] = useState(getUserDetails()?.mineId || "");

  const Gangman = [
    { label: "Gangman", value: 1 },
    { label: "Asst. Gangman", value: 2 },
    { label: "Asst. Gangman 1", value: 3 },
    { label: "Asst. Gangman 2", value: 4 },
    { label: "Asst. Gangman 3", value: 5 },
    { label: "Gang member", value: 6 },
  ];

  const allocation = [
    { label: "Mining", value: 1 },
    { label: "Development", value: 2 },
    { label: "Filling Dropping", value: 3 },
    { label: "Filling Spreading", value: 4 },
    { label: "Concreting", value: 5 },
    { label: "Transport", value: 6 },
    { label: "D/R", value: 7 },
    { label: "MISC", value: 8 },
  ];

  const shiftData = [
    { label: "1st Shift", value: 1 },
    { label: "2nd Shift", value: 2 },
    { label: "3rd Shift", value: 3 },
    { label: "General Shift", value: 4 },
  ];

  const {
    data: attendanceDetails,
    isFetching,
    refetch,
  } = useQuery(["getActivityById", activityDate, createdById, shift, gangNo], () => communication?.getAttendanceByActivity({ date: activityDate, createdById, shift, gangNo }), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        !selectedGangNo && setSelectedGangNo(data?.data?.attendance?.[0]?.gangNo);
        !selectedGangObj && setSelectedGangObj(data?.data?.attendance?.[0]);
        !selectedGangObj && prevSetSelectedGangObj(data?.data?.attendance?.[0]);
        setAttendanceData(data?.data?.attendance);
        setFilteredAttendaceData(data?.data?.attendance);
      } else if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });

  const { mutate, isLoading: updateAttendanceLoading } = useMutation((data) => communication?.updateAttendance(data), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        toast.success(`Success : ${data?.data?.message}`);
        refetch();
        setEditIndex("");
      } else if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
        setEditIndex("");
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
        setEditIndex("");
      }
    },
    onError: (error) => {
      toast.error(`Failed to update status: ${error?.message}`);
    },
  });

  const handleGangSearch = React.useCallback((search) => {
    const lowerSearch = search.toLowerCase();

    const filterData = attendanceData?.filter((ele) => {
      return ele?.gangNo?.toLowerCase().includes(lowerSearch) || ele?.gangMan?.toLowerCase().includes(lowerSearch);
    });
    setSelectedGangNo(filterData?.[0]?.gangNo);
    setSelectedGangObj(filterData?.[0]);
    setFilteredAttendaceData(filterData);
  }, [attendanceData]);

  React.useEffect(() => {
    if (attendanceData) {
      handleGangSearch(globalSearchString || "");
    }
  }, [globalSearchString, attendanceData, handleGangSearch]);

  const getGangwisePresentAbsentEmployee = () => {
    let present = 0;
    let absent = 0;
    selectedGangObj?.gang?.map((ele) => {
      if (ele?.attendance > 0) {
        present = Number(present) + Number(ele?.attendance);
      }
      if (ele?.attendance == 0) {
        absent++;
      }
    });
    return { present, absent };
  };
  const getTotalPresentAbsentEmployee = () => {
    let present = 0;
    let absent = 0;
    attendanceDetails?.data?.attendance?.map((data) => {
      data?.gang?.map((ele) => {
        if (ele?.attendance > 0) {
          present = Number(present) + Number(ele?.attendance);
        }
        if (ele?.attendance == 0) {
          absent++;
        }
      });
    });
    return { present, absent };
  };

  const handleAttendanceUpdate = () => {
    let validationFailed = false;
    selectedGangObj?.gang?.map((data) => {
      if ([undefined, null, ""]?.includes(data?.attendance)) {
        validationFailed = true;
      }
    });
    if (validationFailed) {
      toast.error("Attendance fields must be filled! Kindly check and enter the missing Attendance.");
      return;
    }
    mutate({ id: selectedGangObj?._id, ...selectedGangObj });
  };

  return (
    <div style={{ padding: "16px 24px" }}>
      {(isFetching || updateAttendanceLoading) && <Loader />}

      <div className="pageWrapper">
        <div className="attendancePresentAbsentWrapper">
          <div>
            <h6>Total Present Employee: {filteredAttendaceData?.length > 0 ? getTotalPresentAbsentEmployee()?.present : 0}</h6>
            <h6>Total Absent Employee: {filteredAttendaceData?.length > 0 ? getTotalPresentAbsentEmployee()?.absent : 0}</h6>
          </div>
        </div>
        <div className="reportGreenBtnWrapper">
          {filteredAttendaceData?.map((ele) => {
            return (
              <GreenButton
                text={`${ele?.gangNo} - ${ele?.gangMan || "N/A"}`}
                isOutLined={selectedGangNo != ele?.gangNo}
                className={"text-capitalize"}
                onClick={() => {
                  setSelectedGangNo(ele?.gangNo);
                  setSelectedGangObj(ele);
                  prevSetSelectedGangObj(ele);
                }}
              />
            );
          })}
        </div>
      </div>
      <div className="filterWrapper comman-box-shadow">
        <BlueHeading text={"Attendance Details"} />
        <div className="mb-3">
          <div className="infoWithLabelWrapper">
            <label>Gang No:</label>
            <p className="text-capitalize">{selectedGangObj?.gangNo || "--"}</p>
          </div>
          <div className="infoWithLabelWrapper">
            <label>No. Of Employee:</label>
            <p className="text-capitalize">{selectedGangObj?.gang?.length || 0}</p>
          </div>
          <div className="infoWithLabelWrapper">
            <label>Present Employee:</label>
            <p className="text-capitalize">{getGangwisePresentAbsentEmployee()?.present}</p>
          </div>
          <div className="infoWithLabelWrapper">
            <label>Absent Employee:</label>
            <p className="text-capitalize">{getGangwisePresentAbsentEmployee()?.absent}</p>
          </div>
          <div className="infoWithLabelWrapper">
            <label>Shift:</label>
            <p className="text-capitalize">{shiftData?.find((e) => e?.value == selectedGangObj?.shift)?.label || "--"}</p>
          </div>
          <div className="infoWithLabelWrapper">
            <label> Level:</label>
            <p className="text-capitalize">{selectedGangObj?.level || "--"}</p>
          </div>
          <div className="infoWithLabelWrapper">
            <label>Section:</label>
            <p className="text-capitalize">{selectedGangObj?.section || "--"}</p>
          </div>
        </div>
      </div>

      <div className="pageWrapper">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
          <SelectMine selectedMine={selectedMine} onChange={(e) => setSelectedMine(e.target.value)} />
        </div>
        <div className="tableWrapper comman-box-shadow" style={{ position: "relative" }}>
          <table>
            <thead>
              <tr>
                <th className="col_200px">Personnal No</th>
                <th className="col_350px">Name Of Employee</th>
                <th className="col_350px">Designation (Position)</th>
                <th className="col_200px">Allocation</th>
                <th className="col_200px">Gangman</th>
                <th className="col_200px">Attendance</th>
                {/* {action=='true' && <th className="col_150px text-center row-fix-to-last">Action</th>} */}
              </tr>
            </thead>
            <tbody>
              {selectedGangObj?.gang?.map((ele, index) => {
                return (
                  <tr className={index % 2 == 0 && "skyBlueTrBg"}>
                    <td>
                      {" "}
                      <InputBox value={ele?.employeeNo} disabled={true} style={{ textTransform: "capitalize" }} />
                    </td>
                    <td>
                      {" "}
                      <InputBox value={ele?.name} disabled={true} style={{ textTransform: "capitalize" }} />
                    </td>
                    <td>
                      {" "}
                      <InputBox value={ele?.empSubGrp} disabled={true} style={{ textTransform: "capitalize" }} />
                    </td>
                    <td>
                      <InputBox value={allocation?.find((e) => e?.value == ele?.allocation)?.label} disabled={true} style={{ textTransform: "capitalize" }} />
                    </td>
                    <td>
                      <InputBox value={Gangman?.find((e) => e?.value == ele?.gangm)?.label} disabled={true} style={{ textTransform: "capitalize" }} />
                    </td>
                    <td>
                      {" "}
                      <InputBox value={ele?.attendance} disabled={true} />
                    </td>
                    {/* <td>
                      <select
                        name=""
                        id=""
                        className="attendanceSelect"
                        disabled={editIndex === index ? false : true}
                        style={{ borderWidth: editIndex === index ? "2px" : "1px" }}
                        onChange={(e) => {
                          setSelectedGangObj((prev) => {
                            // Create a deep copy of the object to avoid direct mutation
                            const updatedData = { ...prev, gang: [...prev.gang] };

                            // Update the specific index safely
                            updatedData.gang[editIndex] = {
                              ...updatedData.gang[editIndex],
                              attendance: e.target.value,
                            };

                            return updatedData;
                          });
                        }}
                      >
                        <option value={1} selected={ele?.attendance == 1}>
                          1
                        </option>
                        <option value={0.5} selected={ele?.attendance == 0.5}>
                          0.5
                        </option>
                        <option value={0} selected={ele?.attendance == 0}>
                          0
                        </option>
                      </select>
                    </td> */}

                    {/* {action=='true' && (
                      <td className="text-center row-fix-to-last">
                        {editIndex === index && (
                          <button
                            className="cancelIconBtn"
                            onClick={() => {
                              setSelectedGangObj(prevSelectedGangObj);
                              setEditIndex("");
                            }}
                          >
                            ❌
                          </button>
                        )}
                        <button
                          className="editIconBtn"
                          style={{ border: editIndex === index && "2px solid #34c759" }}
                          onClick={() => (editIndex === index ? handleAttendanceUpdate() : setEditIndex(index))}
                        >
                          {editIndex === index ? "✔" : svgData?.editIcon}
                        </button>
                      </td>
                    )} */}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {(!selectedGangObj?.gang || selectedGangObj?.gang.length === 0) && <h6 className="noDataAvailableWrapper">No Data Available</h6>}
        </div>
      </div>
    </div>
  );
}
// {(!attendanceDetails?.data?.attendance || attendanceDetails?.data?.attendance?.length === 0) && <h6 className="noDataAvailableWrapper">No Data Available</h6>}
